const specialties = [
  { icon: 'ri-brain-line', label: 'Неврологи' },
  { icon: 'ri-heart-pulse-line', label: 'Терапевты' },
  { icon: 'ri-heart-line', label: 'Кардиологи' },
  { icon: 'ri-walk-line', label: 'Реабилитологи' },
  { icon: 'ri-parent-line', label: 'Педиатры' },
  { icon: 'ri-surgical-mask-line', label: 'Нейрохирурги' },
  { icon: 'ri-first-aid-kit-line', label: 'Анестезиологи' },
  { icon: 'ri-capsule-line', label: 'Клин. фармакологи' },
  { icon: 'ri-pulse-line', label: 'Эпилептологи' },
  { icon: 'ri-speak-line', label: 'Логопеды' },
  { icon: 'ri-graduation-cap-line', label: 'Студенты' },
  { icon: 'ri-stethoscope-line', label: 'Ординаторы' },
];

export default function ForWhomSection() {
  return (
    <section id="for-whom" className="py-20 md:py-28 bg-[#f5f2ed]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-14 items-center">
          {/* Left text */}
          <div className="w-full lg:w-[42%]">
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#c8963e] mb-4">
              Участники
            </span>
            <h2 className="text-3xl md:text-5xl font-extrabold text-[#0f3d32] mb-6 leading-tight">
              Кому будет<br />полезно
            </h2>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
              Конференция рассчитана на практикующих врачей разных специальностей, которые сталкиваются с междисциплинарными вопросами и хотят говорить с коллегами честно.
            </p>
            <div className="bg-white rounded-2xl p-6 border-l-4 border-[#1a6b5a] mb-4">
              <p className="text-[#0f3d32] text-base font-medium leading-relaxed">
                Если вы ведёте пациентов с коморбидностью, болью, когнитивными нарушениями — эта конференция для вас.
              </p>
            </div>

            <div className="bg-[#1a6b5a]/8 rounded-2xl p-5 flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-[#c8963e] rounded-xl shrink-0 mt-0.5">
                  <i className="ri-government-line text-white text-base"></i>
                </div>
                <p className="text-[#0f3d32] text-sm leading-relaxed">
                  <span className="font-bold uppercase tracking-wide text-[#c8963e]">Комитетом по здравоохранению СПб</span>&nbsp;ежегодная Всероссийская конференция&nbsp;<span className="font-extrabold">«NeuroRussia2026»</span> включена в план проведения научно-образовательных мероприятий в Санкт-Петербурге&nbsp;
                </p>
              </div>
              <p className="text-[#0f3d32]/70 text-sm pl-12">
                Вы можете официально отпрашиваться с работы для участия в конференции.
              </p>
              <a
                href="/pismo.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 ml-12 text-[#1a6b5a] font-semibold text-sm hover:text-[#c8963e] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-file-pdf-2-line text-base"></i>
                </div>
                Скачать официальное письмо
              </a>
            </div>
          </div>

          {/* Right grid */}
          <div className="w-full lg:w-[58%]">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4">
              {specialties.map((s) => (
                <div
                  key={s.label}
                  className="bg-white rounded-2xl p-3 sm:p-5 flex flex-col sm:flex-row items-center sm:items-center gap-2 sm:gap-4 hover:-translate-y-1 transition-transform duration-200"
                >
                  <div className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-[#1a6b5a]/8 rounded-xl shrink-0">
                    <i className={`${s.icon} text-[#1a6b5a] text-lg sm:text-xl`}></i>
                  </div>
                  <span className="text-[#0f3d32] font-semibold text-xs sm:text-sm leading-tight text-center sm:text-left">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
